import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiCall } from '../lib/api';
import type { ListRewardsOutput } from '@meso/types';

export function Rewards() {
  const qc = useQueryClient();
  const list = useQuery<ListRewardsOutput>({
    queryKey: ['rewards'],
    queryFn: () => apiCall<ListRewardsOutput>('get', '/rewards'),
  });

  const redeem = useMutation({
    mutationFn: (reward_id: string) => apiCall('post', '/rewards/redeem', { reward_id }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['rewards'] });
      qc.invalidateQueries({ queryKey: ['me'] });
    },
  });

  if (list.isLoading) return <div className="p-6 text-center text-gray-500">กำลังโหลด...</div>;

  const points = list.data?.customer_points ?? 0;
  const available = list.data?.available ?? [];

  return (
    <div className="max-w-md mx-auto px-4 py-6">
      <h1 className="text-xl font-bold mb-4">แลกรางวัล</h1>

      <div className="card bg-gradient-to-br from-gray-800 to-black text-white mb-4">
        <div className="text-xs opacity-70">คะแนนสะสมของคุณ</div>
        <div className="text-3xl font-bold">{points.toLocaleString('th-TH')} คะแนน</div>
      </div>

      {available.length === 0 && (
        <div className="card text-center py-12 text-gray-500">
          ยังไม่มีของรางวัลในขณะนี้
        </div>
      )}

      <div className="space-y-3">
        {available.map((r) => {
          const canRedeem = points >= r.cost;
          return (
            <div key={r.id} className="card flex items-center gap-3">
              {r.image_url ? (
                <img src={r.image_url} alt="" className="w-16 h-16 rounded-lg object-cover" />
              ) : (
                <div className="w-16 h-16 rounded-lg bg-gray-100 flex items-center justify-center text-2xl">🎁</div>
              )}
              <div className="flex-1">
                <div className="font-bold text-sm">{r.title}</div>
                {r.description && <div className="text-xs text-gray-500 mt-1">{r.description}</div>}
                <div className="text-sm font-semibold mt-1">{r.cost.toLocaleString('th-TH')} คะแนน</div>
              </div>
              <button
                onClick={() => redeem.mutate(r.id)}
                disabled={!canRedeem || redeem.isPending}
                className={`btn text-xs px-4 py-1.5 ${canRedeem ? 'btn-primary' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`}
              >
                {canRedeem ? 'แลก' : 'คะแนนไม่พอ'}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
